import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { BrowserModule } from "@angular/platform-browser";
import { provideOutlet, OutletPosition } from "@spartacus/storefront";
import { SanofiRulesComponent } from "./sanofi-rules/sanofi-rules.component";


@NgModule({
  declarations: [SanofiRulesComponent],
  imports:[
    CommonModule,
    BrowserModule,
    FormsModule,
    ReactiveFormsModule
  ],
  providers: [
    provideOutlet({
      id: 'ShippingRuleSlot',
      position: OutletPosition.REPLACE,
      component: SanofiRulesComponent,
    }),
  ]
})
export class SanofiRulesModule { }
